import { bergerSchedule, doubleBergerSchedule } from './roundrobin.js';
import {
  PairingError,
  type PairingEngine,
  type PairingRequest,
  type PairingResult,
} from './types.js';

/**
 * Round robin as a pairing engine: the round's pairs come straight from the
 * Berger tables by pairing number. Availability is ignored (a missing player's
 * game is entered as a forfeit, as round-robin rules require).
 */
export class RoundRobinEngine implements PairingEngine {
  readonly id: string;
  readonly name: string;

  constructor(private readonly double = false) {
    this.id = double ? 'double-round-robin' : 'round-robin';
    this.name = double ? 'Double round robin (Berger)' : 'Round robin (Berger)';
  }

  pair(request: PairingRequest): PairingResult {
    const n = request.players.length;
    const schedule = this.double ? doubleBergerSchedule(n) : bergerSchedule(n);
    const r = schedule[request.round - 1];
    if (r === undefined) {
      throw new PairingError(
        `a ${this.name.toLowerCase()} of ${n} players has only ${schedule.length} rounds`,
      );
    }
    return { pairs: r.pairs, byes: r.bye === null ? [] : [r.bye], notes: [] };
  }
}
